function convertRankineToCelsius(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to celsius: \n" +
    "((" +
    num +
    " - 491.67) * 5) / 9 = ";
  let rep = ((num - 491.67) * 5) / 9;
  return eq + rep.toFixed(3);
}

function convertRankineToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to fahrenheit: \n" +
    num +
    " - 459.67 = ";
  let rep = num - 459.67;
  return eq + rep.toFixed(3);
}

function convertRankineToKelvin(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to kelvin: \n" +
    "(" +
    num +
    " * 5) / 9 = ";
  let rep = (num * 5) / 9;
  return eq + rep.toFixed(2);
}

function convertRankineToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to delisle: \n" +
    "((671.67 - " +
    num +
    ") * 5) / 6 = ";
  let rep = ((671.67 - num) * 5) / 6;
  return eq + rep.toFixed(3);
}

function convertRankineToNewton(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to newton: \n" +
    "((" +
    num +
    " - 491.67) * 11) / 60 = ";
  let rep = ((num - 491.67) * 11) / 60;
  return eq + rep.toFixed(3);
}

function convertRankineToRéaumur(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to réaumur: \n" +
    "((" +
    num +
    " - 491.67 )* 4) / 9 = ";
  let rep = ((num - 491.67) * 4) / 9;
  return eq + rep.toFixed(3);
}

function convertRankineToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° rankine to rømer: \n" +
    "(((" +
    num +
    " - 491.67) * 7) / 24) + 7.5 = ";
  let rep = ((num - 491.67) * 7) / 24 + 7.5;
  return eq + rep.toFixed(3);
}

export {
  convertRankineToRømer,
  convertRankineToRéaumur,
  convertRankineToNewton,
  convertRankineToDelisle,
  convertRankineToKelvin,
  convertRankineToFahrenheit,
  convertRankineToCelsius
};
